import { Card, Empty } from 'antd';
export default function RequirementPage() {
  return <Card style={{marginTop:16}} title="需求分析"><Empty description="请在AI全流程中完成需求分析" /></Card>;
}
